import React, { useState, useEffect } from 'react'
import { HTTP } from '../../api/resources'
import UserAvatar from '../Avatar/UserAvatar.js'
import TimeAgo from '../Helpers/Functions/TimeAgo.js'

export default function PostComment({post, current_user, representProject, team}) {
    const [mainComment, setMainComment] = useState('')
    const [comments, setComments] = useState([])
    const [saving, setSaving] = useState(false)
    const [showReplies, setShowReplies] = useState(0)
    const [isOpen, setIsOpen] = useState(false)
    const [replying, setReplying] = useState(null)
    const [reply, setReply] = useState('')
    const [editing, setEditing] = useState(false)
    const [isReply, setIsReply] = useState(false)
    const [truncateId, setTruncateId] = useState(null)
    const [canCommentAsProject, setCanCommentAsProject] = useState(representProject)
    const [commentAsProject, setCommentAsProject] = useState(false)
    let isManager = current_user.user_type == 'manager' || current_user.user_type == 'assistant_manager'
    let sponsorshipManager = post.user_id && post.user.user_type == 'beneficiary' && current_user.user_type == 'sponsorship_manager' && current_user.sponsorship_group && current_user.sponsorship_group.beneficiary_ids.includes(post.user_id)
    let projectManager = post.project_id && current_user.user_type.includes('project') && current_user.project_ids && current_user.project_ids.includes(post.project_id)
    let isOwner = current_user.id == post.user_id

    useEffect(() => {
        fetchComments()
    }, [])

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            let commentID = hash.replace('#comment-', '')
            commentID = parseInt(commentID)
            let comment = comments.find(comment => comment.id == commentID)
            if (!comment) {
                let parentComment = comments.find(comment => comment.replies.find(reply => reply.id == commentID))
                if (parentComment) {
                    setShowReplies(parentComment.id)
                }
            }
            const element = document.getElementById(`comment-${commentID}`);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [comments])

    const toggleDropdown = (msg) => {
        if (isOpen && isOpen == msg.id) setIsOpen(false)
        if (!isOpen) setIsOpen(msg.id)
        if (isOpen && isOpen != msg.id) setIsOpen(msg.id)
    }

    const handleDelete = async (comment) => {
        setSaving(true)

        try {
            await deleteRequest(comment)
            Alert.show('notice', 'Commend deleted successfully')
            setTimeout(() => window.location.reload(), 1500)
        } catch {
            Alert.show('error', 'Comment deletion failed, try again')
            setSaving(false)
        }
    }

    const deleteRequest = (comment) => {
        return HTTP.delete(`/posts/comments/${comment.id}`)
    }

    const type = (userType) => {
        let name = userType ? userType.replace('_', ' ') : team.project_title.toLowerCase()
        return name
    }

    const fetchComments = async () => {
        setSaving(true)

        try {
            let response = await fetchRoute()
            setComments(response.data ? response.data.filter(comment => !comment.sender.archived) : [])
            setSaving(false)
        } catch {
            Alert.show('notice', 'An error occured, please reload')
            // setTimeout(() => window.location.reload(), 1500)
        }
    }

    const fetchRoute = () => {
        return HTTP.get(`/posts/comments/${post.id}`)
    }

    const createNewComment = async () => {
        setSaving(true)

        try {
            await createRoute()
            Alert.show('notice', 'Comment sent successfully')
            setTimeout(() => window.location.reload(), 1500)
        } catch {
            Alert.show('error', 'Unable to create comment, try again')
            setSaving(false)
        }
    }

    const createRoute = () => {
        return HTTP.post(
            `/posts/comments/${post.id}?project=${commentAsProject}`, 
            {
                value: replying ? reply : mainComment, 
                parent_id: replying
            }
        )
    }

    const displayText = (text) => {
        var paragraphs = text.split('\n').map(function(line) {
            return '<p>' + line + '</p>';
        }).join('');
        return paragraphs
    }

    const updateComment = async () => {
        setSaving(true) 

        try {
            await editRoute()
            Alert.show('notice', 'Comment updated successfully')
            setTimeout(() => window.location.reload(), 1500)
        } catch {
            Alert.show('error', 'Could not update comment, try again')
            setSaving(false)
        }
    }

    const editRoute = () => {
        return HTTP.patch(
            `/posts/comments/${post.id}/${editing}`, 
            {value: isReply ? reply : mainComment}
        )
    }

    const approveComment = async (val, id) => {
        setSaving(true)

        try {
            await approveRoute(val, id)
            Alert.show('notice', 'Comment status updated')
            setTimeout(() => window.location.reload(), 1500)
        } catch {
            Alert.show('error', 'Comment status could not be updated, try again')
            setSaving(false)
        }
    }

    const approveRoute = (value, id) => {
        return HTTP.patch(
            `/posts/comments/${post.id}/${id}/approve`, 
            {approved: value}
        )
    }

    const filteredReplies = (replies) => {
        if (isManager || sponsorshipManager || projectManager) return replies 
        if (canApprove()) return replies
        if (!replies || (replies && replies.length < 1)) return []

        let rep = replies.filter(reply => {
            if (reply.sender.id == current_user.id) return reply 
            if (reply.approved) return reply
        })

        return rep ? rep : []
    }

    const truncateText = (text, id) => {
        if (text && text.length > 200) {
            if (truncateId !== id) return text.substring(0, 200) + '...'
            if (truncateId == id) return text
        } else {
            return text
        }
    }

    const editAccess = (sender) => {
        if (current_user.user_type == 'sponsorship_manager' && current_user.get_sponsorship_manager_profiles_ids.includes(sender.id)) return true

        if (current_user.user_type === 'project_manager' && canCommentAsProject && sender.project_manager && sender.project_manager === current_user.id) {
            return true
        }
    }

    const canApprove = (sender = null) => {
        if (isManager) return true;

        if ((current_user.user_type == "project_manager" || current_user.user_type == "project_coordinator")
            && post.project && current_user.project_manager_permissions.includes('comment_approval')) {
            return true;
        }

        if (current_user.user_type == 'sponsorship_manager' && post.user.user_type == 'beneficiary' 
            && current_user.sponsorship_manager_permissions.includes('comment_approval')) {
            return true
        }

        if (current_user.user_type == 'sponsorship_manager' && sender && current_user.get_sponsorship_manager_profiles_ids.includes(sender.id)
            && current_user.sponsorship_manager_permissions.includes('comment_approval')) {
            return true
        }

        if (current_user.user_type == 'sponsorship_manager' && post.user_id && current_user.id == post.user_id
            && current_user.sponsorship_manager_permissions.includes('comment_approval')) {
                return true
        }

        if ((current_user.user_type == "project_manager" || current_user.user_type == "project_coordinator")
            && post.user_id && post.user_id == current_user.id && current_user.project_manager_permissions.includes('comment_approval')) {
            return true;
        }
        
        return false
    }

    const canSeeApprovalStatus = (sender = null) => {
        if (isManager) return true;

        if ((current_user.user_type == "project_manager" || current_user.user_type == "project_coordinator")
            && post.project) {
            return true;
        }

        if (current_user.user_type == 'sponsorship_manager' && post.user && post.user.user_type == 'beneficiary') {
            return true
        }

        if (current_user.user_type == 'sponsorship_manager' && sender && current_user.get_sponsorship_manager_profiles_ids.includes(sender.id)
            && current_user.sponsorship_manager_permissions.includes('comment_approval')) {
            return true
        }

        if (current_user.user_type == 'sponsorship_manager' && post.user_id && current_user.id == post.user_id) {
            return true
        }

        if ((current_user.user_type == "project_manager" || current_user.user_type == "project_coordinator")
            && post.user_id && post.user_id == current_user.id) {
            return true;
        }
        
        return false
    }

  return (
    <div>
        <div className='card'>
            <div className='card-body'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <div className='input-group'>
                                <textarea
                                    type='text'
                                    id='main_comment'
                                    name='main_comment'
                                    className='form-control'
                                    placeholder='Write a comment.....'
                                    value={mainComment}
                                    onChange={(event) => {
                                        if (event.target.value.length > 5000) {
                                            Alert.show('notice', 'The maximum number characters if 5000')
                                            return
                                        }
                                        setMainComment(event.target.value ? event.target.value : '')
                                    }}
                                    disabled={replying}
                                />
                                <div className="input-group-append">
                                    <button 
                                        className="btn btn-light btn-border" 
                                        type="button" 
                                        id='send_comment'
                                        onClick={() => {
                                            if (editing) {
                                                updateComment()
                                            } else {
                                                createNewComment()
                                            }
                                        }}
                                        disabled={mainComment.length < 1 || saving || replying}
                                    >
                                        {saving && !replying && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                                        <i className="fas fa-paper-plane"></i>
                                    </button>

                                    {editing && !isReply &&
                                        <button 
                                            className="btn btn-light btn-border" 
                                            type="button" 
                                            onClick={() => {
                                                setMainComment('')
                                                setEditing(false)
                                            }}
                                            disabled={saving}
                                        >
                                            <i class="fas fa-window-close text-danger"></i>
                                        </button>
                                    }
                                </div>
                            </div>
                            <p style={{textAlign: 'right', padding: '0px 2px 0px 2px', marginBottom: '0px'}}>
                                <small className='text-muted'>{ mainComment.length } of 5000 characters</small>
                            </p> 

                            {canCommentAsProject && post.project_id && 
                                <div>
                                    <div className="form-check" style={{padding: '0px 2px 0px 2px'}}>
                                    <label className="form-check-label">
                                        <input 
                                            class="form-check-input" 
                                            type="checkbox"
                                            checked={commentAsProject}
                                            disabled={!canCommentAsProject}
                                            onChange={() => setCommentAsProject(!commentAsProject)}
                                        />
                                        <span class="form-check-sign">Comment as {team.project_title.toLowerCase()}</span>
                                    </label>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-12'>
                        <div className='comments-display' id="messages" style={{minHeight: '30vh !important'}}>
                            <ul>
                                {comments.length < 1 &&
                                    <li className='empty-message'>
                                        No comments at the moment, be the first to send a comment
                                    </li>
                                }

                                {comments && comments.map(msg => (
                                    <div key={msg.id}>
                                        <li id={`comment-${msg.id}`}>
                                            <div className='d-flex'>
                                                <UserAvatar url={ msg.sender.avatar_url } fallback={msg.sender.name} />
                                                <div className='ml-2'>
                                                    <b onClick={() => window.location = `/b/${msg.sender.id}`} style={{cursor: 'pointer'}}>
                                                        { `${msg.sender.name}` }

                                                        {!msg.approved && (current_user.id == msg.sender.id || canSeeApprovalStatus(msg.sender)) &&
                                                        <small className='text-danger ml-3'>Pending Approval</small>
                                                        }

                                                        {msg.approved && (current_user.id == msg.sender.id || canSeeApprovalStatus(msg.sender)) &&
                                                        <small className='text-success ml-3'>Approved</small>
                                                        }

                                                        <span className='badge ml-3'>{ type(msg.sender.user_type) }</span>
                                                    </b>
                                                    <div className="mb-1" style={{fontSize: '12px'}}>
                                                        <i>{ msg.created_at_in_words }</i>
                                                    </div>
                                                    <div className='message-container' style={{wordBreak: 'break-word'}}>
                                                        <div dangerouslySetInnerHTML={{__html: displayText(truncateText(msg.value, msg.id))}}></div>
                                                        {truncateText(msg.value, msg.id).length <= 203 && 
                                                         msg.value.length > 200 &&
                                                            <span 
                                                                className='text-blue' 
                                                                onClick={() => { setTruncateId(msg.id) } }
                                                                style={{cursor: 'pointer', color: 'blue'}}
                                                            > 
                                                                {' show more'}
                                                            </span>
                                                        }
                                                        {truncateText(msg.value, msg.id).length > 203 &&
                                                            <span 
                                                                className='text-blue' 
                                                                onClick={() => {setTruncateId(0)}} 
                                                                style={{cursor: 'pointer', color: 'blue'}}
                                                            > 
                                                                {'  show less'}
                                                            </span>
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card-actions">
                                                <div className="dropleft d-block">
                                                    <button className="btn btn-icon cu-for-action-text" type="button" onClick={() => toggleDropdown(msg)} style={{ background: 'none' }} >
                                                        <i className="far fa-ellipsis-v"></i>
                                                    </button>

                                                    {isOpen == msg.id &&
                                                        <div className="dropdown-menu" style={{ display: 'block' }}>
                                                            {(isManager || current_user.id == msg.sender.id || editAccess(msg.sender)) &&
                                                                <span 
                                                                    className='dropdown-item'
                                                                    onClick={() => {
                                                                        setEditing(msg.id)
                                                                        setIsReply(false)
                                                                        setIsOpen(false)
                                                                        setReplying(null)
                                                                        setMainComment(msg.value)
                                                                    }}
                                                                    style={{cursor: 'pointer'}}
                                                                >
                                                                    Edit
                                                                </span>
                                                            }

                                                            {canApprove(msg.sender) && msg.sender.user_type != 'manager' && msg.sender.user_type != 'assistant_manager' &&
                                                                <span 
                                                                    className={!msg.approved ? 'dropdown-item text-success' : 'dropdown-item text-danger'}
                                                                    onClick={() => {
                                                                        if (msg.approved){
                                                                            approveComment(false, msg.id)
                                                                        } else {
                                                                            approveComment(true, msg.id)
                                                                        }
                                                                    }}
                                                                    style={{cursor: 'pointer'}}
                                                                >
                                                                    {msg.approved && <>Unapprove</>}
                                                                    {!msg.approved && <>Approve</>}
                                                                </span>
                                                            }

                                                            <span 
                                                                className='dropdown-item'
                                                                onClick={() => {
                                                                    if (showReplies != msg.id) setShowReplies(msg.id)
                                                                    if (showReplies == msg.id) setShowReplies(false)
                                                                    setIsOpen(false)
                                                                    setReplying(null)
                                                                }}
                                                                style={{cursor: 'pointer'}}
                                                            >
                                                                {showReplies == msg.id && <>Hide Replies</>}
                                                                {showReplies != msg.id && <>Show Replies</>}
                                                            </span>

                                                            {replying != msg.id &&
                                                                <span 
                                                                    className='dropdown-item'
                                                                    onClick={() => {
                                                                        if (replying != msg.id) setReplying(msg.id)
                                                                        if (replying == msg.id) setReplying(null)
                                                                        setIsOpen(false)
                                                                    }}
                                                                    style={{cursor: 'pointer'}}
                                                                >
                                                                    Reply
                                                                </span>
                                                            }

                                                            {(isManager || current_user.id == msg.sender.id || editAccess(msg.sender)) &&
                                                                <span 
                                                                    className='dropdown-item text-danger'
                                                                    onClick={() => {
                                                                        if (window.confirm('This action cannot be reversed')){
                                                                            handleDelete(msg)
                                                                        }
                                                                    }}
                                                                    style={{cursor: 'pointer'}}
                                                                >
                                                                    Delete
                                                                </span>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </li>

                                        {filteredReplies(msg.replies) && showReplies == msg.id && filteredReplies(msg.replies).length > 0 &&
                                            <div>
                                                <div>
                                                    <div style={{width: '95%', marginLeft: 'auto'}}>
                                                        <div className='comments-display' id="messages" style={{minHeight: '3vh !important'}}>
                                                            <ul>
                                                                {filteredReplies(msg.replies).map(reply => (
                                                                    <li id={`comment-${reply.id}`} key={reply.id}>
                                                                        <div className='d-flex'>
                                                                            <UserAvatar url={ reply.sender.avatar_url } fallback={reply.sender.name} />
                                                                            <div className='ml-2'>
                                                                                <b onClick={() => window.location = `/b/${reply.sender.id}`} style={{cursor: 'pointer'}}>
                                                                                    { `${reply.sender.name}` }
                                                                                {!reply.approved && (current_user.id == reply.sender.id || canSeeApprovalStatus(reply.sender)) &&
                                                                                <small className='text-danger ml-3'>Pending Approval</small>
                                                                                }
                                                                                {reply.approved && (current_user.id == reply.sender.id || canSeeApprovalStatus(reply.sender)) &&
                                                                                <small className='text-success ml-3'>Approved</small>
                                                                                }
                                                                                    <span className='badge ml-3'>{ type(reply.sender.user_type) }</span>
                                                                                </b>
                                                                                <div className="mb-1" style={{fontSize: '12px'}}>
                                                                                    <i>{ msg.created_at_in_words }</i>
                                                                                </div>
                                                                                <div className='message-container'>
                                                                                    <div dangerouslySetInnerHTML={{__html: displayText(truncateText(reply.value, reply.id))}}></div>
                                                                                    {truncateText(reply.value, reply.id).length <= 203 && 
                                                                                    reply.value.length > 200 &&
                                                                                        <span 
                                                                                            className='text-blue' 
                                                                                            onClick={() => { setTruncateId(reply.id) } }
                                                                                            style={{cursor: 'pointer', color: 'blue'}}
                                                                                        > 
                                                                                            {' show more'}
                                                                                        </span>
                                                                                    }
                                                                                    {truncateText(reply.value, reply.id).length > 203 &&
                                                                                        <span 
                                                                                            className='text-blue' 
                                                                                            onClick={() => {setTruncateId(0)}} 
                                                                                            style={{cursor: 'pointer', color: 'blue'}}
                                                                                        > 
                                                                                            {'  show less'}
                                                                                        </span>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="card-actions">
                                                                            <div className="dropleft d-block">
                                                                                <button className="btn btn-icon cu-for-action-text" type="button" onClick={() => toggleDropdown(reply)} style={{ background: 'none' }} >
                                                                                    <i className="far fa-ellipsis-v"></i>
                                                                                </button>

                                                                                {isOpen == reply.id &&
                                                                                    <div className="dropdown-menu" style={{ display: 'block' }}>
                                                                                        {(isManager || current_user.id == reply.sender.id || editAccess(reply.sender)) &&
                                                                                            <span 
                                                                                                className='dropdown-item'
                                                                                                onClick={() => {
                                                                                                    setEditing(reply.id)
                                                                                                    setIsReply(reply.id)
                                                                                                    setIsOpen(false)
                                                                                                    setReplying(msg.id)
                                                                                                    setReply(reply.value)
                                                                                                }}
                                                                                                style={{cursor: 'pointer'}}
                                                                                            >
                                                                                                Edit
                                                                                            </span>
                                                                                        }

                                                                                        {canApprove(reply.sender) && reply.sender.user_type != 'manager' && reply.sender.user_type != 'assistant_manager' &&
                                                                                            <span 
                                                                                                className={!reply.approved ? 'dropdown-item text-success' : 'dropdown-item text-danger'}
                                                                                                onClick={() => {
                                                                                                    if (reply.approved){
                                                                                                        approveComment(false, reply.id)
                                                                                                    } else {
                                                                                                        approveComment(true, reply.id)
                                                                                                    }
                                                                                                }}
                                                                                                style={{cursor: 'pointer'}}
                                                                                            >
                                                                                                {reply.approved && <>Unapprove</>}
                                                                                                {!reply.approved && <>Approve</>}
                                                                                            </span>
                                                                                        }

                                                                                        {(isManager || current_user.id == reply.sender.id || editAccess(msg.sender)) &&
                                                                                            <span 
                                                                                                className='dropdown-item text-danger'
                                                                                                onClick={() => {
                                                                                                    if (window.confirm('This action cannot be reversed')){
                                                                                                        handleDelete(reply)
                                                                                                    }
                                                                                                }}
                                                                                                style={{cursor: 'pointer'}}
                                                                                            >
                                                                                                Delete
                                                                                            </span>
                                                                                        }
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {replying == msg.id &&
                                                <div>
                                                    <div>
                                                        <div className='form-group' style={{width: '95%', marginLeft: 'auto'}}>
                                                            <div className='input-group'>
                                                                <textarea
                                                                    type='text'
                                                                    id='reply_comment'
                                                                    name='reply_comment'
                                                                    className='form-control'
                                                                    placeholder='Write a reply.....'
                                                                    value={reply}
                                                                    onChange={(event) => {
                                                                        if (event.target.value.length > 5000) {
                                                                            Alert.show('notice', 'The maximum number characters if 5000')
                                                                            return
                                                                        }
                                                                        setReply(event.target.value ? event.target.value : '')
                                                                    }}
                                                                />
                                                                <div className="input-group-append">
                                                                    <button 
                                                                        className="btn btn-light btn-border" 
                                                                        type="button" 
                                                                        onClick={() => {
                                                                            if (editing) {
                                                                                updateComment()
                                                                            } else {
                                                                                createNewComment()
                                                                            }
                                                                        }}
                                                                        disabled={reply.length < 1 || saving}
                                                                    >
                                                                        {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                                                                        <i className="fas fa-paper-plane"></i>
                                                                    </button>
                                                                    <button 
                                                                        className="btn btn-light btn-border" 
                                                                        type="button" 
                                                                        onClick={() => {
                                                                            setReply('')
                                                                            setReplying(null)
                                                                            setIsReply(false)
                                                                            setEditing(false)
                                                                        }}
                                                                        disabled={saving}
                                                                    >
                                                                        <i class="fas fa-window-close text-danger"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <p style={{textAlign: 'right', padding: '0px 2px 0px 2px', marginBottom: '0px'}}>
                                                                <small className='text-muted'>{ reply.length } of 5000 characters</small>
                                                            </p> 

                                                            {canCommentAsProject && post.project_id && 
                                                                <div>
                                                                    <div className="form-check" style={{padding: '0px 2px 0px 2px'}}>
                                                                    <label className="form-check-label">
                                                                        <input 
                                                                            class="form-check-input" 
                                                                            type="checkbox"
                                                                            checked={commentAsProject}
                                                                            disabled={!canCommentAsProject}
                                                                            onChange={() => setCommentAsProject(!commentAsProject)}
                                                                        />
                                                                        <span class="form-check-sign">Comment as {team.project_title.toLowerCase()}</span>
                                                                    </label>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                    </div>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
